module.exports = __webpack_public_path__ + "img/puzzle4.83ef9bea.png";